import { useGetInfoCategoryMasterData } from '@Domains/MasterData';
import { DataGrid } from '@mui/x-data-grid';
import { select, tidy } from '@tidyjs/tidy';
import { useWatch } from 'react-hook-form';
import { INFO_CATEGORY_MASTER_DATA } from 'src/Enum/MasterData';
import {
  CABON_NEUTRALITY_COLUMNS,
  CABON_NEUTRALITY_VISIBILITY,
} from './CarbonNeutralityColumn';
import { mapCarbonToTable } from './utils';

const CarbonNeutralityTable = () => {
  const [{ data = [] }] = useGetInfoCategoryMasterData([
    INFO_CATEGORY_MASTER_DATA.DEPT_CARBON_NEUTRAL,
    INFO_CATEGORY_MASTER_DATA.GH_GAS_SCOPE,
  ]);

  const carbonMasterData = tidy(data, select(['id', 'nameTh', 'nameEn']));
  const carbonDetails =
    useWatch({
      name: 'greenhouseGoalTerm.carbon.details',
    }) || [];

  const mapCarbonDetails = mapCarbonToTable(carbonDetails, carbonMasterData);

  return (
    <DataGrid
      rows={mapCarbonDetails}
      columns={CABON_NEUTRALITY_COLUMNS}
      getRowHeight={() => 'auto'}
      disableColumnSorting
      initialState={{
        columns: {
          columnVisibilityModel: CABON_NEUTRALITY_VISIBILITY,
        },
      }}
    />
  );
};
export default CarbonNeutralityTable;
